import React from 'react';

import {Navbar} from '@innovago/ui';

export const HeaderPublic = () => {
  return <Navbar topBar={null} bottomBar={[]} />;
};
